import angular from "angular";

angular
    .module('app')
    .component('groupAutomatizationSettings', {
        template: require('./group-automatization-settings.html'),
        controller: ['$http', 'Notifier', '$timeout', controller],
        bindings: {
            group: '<',
            course: '<',
        }
    });

function controller($http, Notifier, $timeout) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.chapters = $ctrl.course.chapters;
    };

    $ctrl.updateLessonHomeworkRequire = function (lesson) {
        let params = {
            lesson: lesson,
        };
        $http.post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-group-lesson-homework-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonQuizRequire = function(lesson) {
        let params = {
            lesson: lesson,
        };
        $http.post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-group-lesson-quiz-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonDelayRequire = function (lesson) {
        let params = {
            lesson: lesson,
        };
        console.log(lesson);
        $http.post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-group-lesson-delay-require`, params).then(
            function (response) {
                Notifier.success('Информация успешно обновлена', 2);
            },

            function (error) {
                Notifier.error('Произошла ошибка', 2);
            });
    };

    $ctrl.updateLessonDelayAmount = function (lesson) {

        if (lesson.can_open_delay != null && lesson.can_open_delay >= 0) {
            let params = {
                lesson: lesson,
            };
            $timeout(function () {
                $http.post(`/admin/courses/${$ctrl.course.id}/groups/${$ctrl.group.id}/update-group-lesson-delay-amount`, params).then(
                    function (response) {
                        Notifier.success('Информация успешно обновлена', 2);
                    },

                    function (error) {
                        Notifier.error('Произошла ошибка', 2);
                    });
            },500);
        } else {
            Notifier.error('Введите значение больше либо равное нулю', 2);
        }
    }
}
